import { render, staticRenderFns } from "./CoordinatorsList.vue?vue&type=template&id=bf5f3912&scoped=true&"
import script from "./CoordinatorsList.vue?vue&type=script&lang=js&"
export * from "./CoordinatorsList.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorsList.vue?vue&type=style&index=0&id=bf5f3912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5f3912",
  null
  
)

export default component.exports